import React, { useState, useEffect } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { SendMessage } from "./api"
import { showNotification } from "aldoo-ra/Notification"
import Value from "aldoo-ra/Value"

const SupportNoteDialog = ({ isOpen, ticketId, onClose, onNoteAdded }) => {
  const [noteText, setNoteText] = useState("")
  const [loading, setLoading] = useState(false)
  const [userProfile] = Value("user-profile")

  useEffect(() => {
    if (isOpen) {
      setNoteText("")
    }
  }, [isOpen])

  const handleSubmit = async () => {
    if (!noteText.trim()) {
      showNotification({
        message: "Please enter a note",
        className: "bg-admin_error text-white",
      })
      return
    }

    try {
      setLoading(true)
      // Get the author from the user profile
      const author = userProfile?._id || userProfile?.id || userProfile?.email
      if (!author) {
        showNotification({
          message: "User information not available",
          className: "bg-admin_error text-white",
        })
        return
      }

      await SendMessage({
        ticketId,
        body: noteText,
        author: author,
        messageType: "note",
      })

      showNotification({
        message: "Note added successfully",
        className: "bg-admin_primary text-admin_text_inv",
      })
      onNoteAdded && onNoteAdded()
      onClose()
    } catch (error) {
      showNotification({
        message: "Failed to add note",
        className: "bg-admin_error text-white",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    // Allow submit with Cmd/Ctrl + Enter
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="admin_compact"
      className="w-full md:w-[700px]"
    >
      <div className="p-4">
        {/* Header */}
        <div className="mb-8">
          <Typography
            component="h4"
            variant="admin_h4"
          >
            Add Support Note - Dialog
          </Typography>
        </div>

        {/* Note Input */}
        <div className="mb-8">
          <textarea
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            onKeyDown={handleKeyDown}
            className="w-full h-[300px] p-4 bg-admin_canvas border border-admin_bordered rounded-md text-admin_text placeholder-admin_neutral_3 resize-none focus:outline-none focus:border-admin_primary/30"
            placeholder="This user was introduced to the discount system"
          />
        </div>

        {/* Submit Button */}
        <div className="flex justify-center">
          <Button
            variant="admin_primary"
            onClick={handleSubmit}
            disabled={loading}
            className="min-w-[200px]"
          >
            {loading ? "Adding Note..." : "Add Note"}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SupportNoteDialog
